import React, { useState } from "react";
import ScrollToTop from "react-scroll-to-top";
import { useTheme } from "@mui/material/styles";
import {
  Button,
  Container,
  Grid,
  Typography,
} from "@mui/material";

import BottomCurved from "../../components/layout/BottomCureved";
import CreateTicket from "../../components/layout/CreateTicket";
import CustomAccordion from "../../components/layout/CustomAccordion";
import SentTicketSuccessModal from "../../components/layout/SentTicketSuccessModal";

import faqData from "./faqData.json";
import "./Help.style.css";


const FaqPage = () => {
  const theme = useTheme();

  const [expanded, setExpanded] = useState('Client Bookings0');
  const [expandedRight, setExpandedRight] = useState('Booking Form Integration0');
  const [createTicketModal, setCreateTicketModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);

  const onCloseCreateTicketModal = () => setCreateTicketModal(false);
  const onCloseSuccessModal = () => setSuccessModal(false);

  const onCreateTicket = () => {
    setCreateTicketModal(true);
  }

  const onCreatedTicketSuccessed = () => {
    setSuccessModal(true);
  }
  const onCloseSuccess = () => {
    onCloseSuccessModal();
    onCloseCreateTicketModal();
  }

  const handleChange = (panel) => setExpanded(panel === expanded ? '' : panel);
  const handleChangeRight = (panel) => setExpandedRight(panel === expanded ? '' : panel);

  return (
    <>
      <BottomCurved />
      <Container maxWidth="lg">
        <Grid
          item
          className="page-title"
          container
          justifyContent='space-between'
          sx={{ my: { sm: 2, md: 5 }, marginInline: 'auto', zIndex: 10 }}
        >
          <Grid item>
            <Typography sx={{ color: '#fff', fontSize: '1.5rem', fontWeight: 600 }}>Support Center</Typography>
          </Grid>
          <Grid item>
            <Button
              onClick={onCreateTicket}
              color="success"
              variant="contained"
              sx={{
                padding: '11px 20px',
                fontSize: '14px',
                fontWeight: 500,
                textTransform: 'none',
                color: '#fff'
              }}
            >
              Create Ticket
            </Button>
          </Grid>
        </Grid>
        <Grid alignItems="center" justifyContent="center" marginTop="40px">
          <Typography sx={{ color: '#fff', fontSize: '40px', fontWeight: '600', textAlign: 'center' }}>Getting Started</Typography>
          <Typography sx={{ color: theme.palette.mode === 'light' ? '#a1a5b7' : '#565674', fontSize: { sm: '17px', md: '20px' }, fontWeight: { sm: '400', md: '500' }, textAlign: 'center', maxWidth: '70%', margin: '0 auto' }}>
            Our advanced tools are designed to <strong style={{ color: '#fff' }}>streamline bookings, save time,</strong> and <strong style={{ color: '#fff' }}>get more clients</strong>. Not sure where to start? <strong style={{ color: '#fff' }}>Let us help.</strong>
          </Typography>
        </Grid>
        <Grid
          container
          spacing={3}
          sx={{ mt: 15, backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#1e1e2d', borderRadius: '8px', p: 5 }}
        >
          {Object.keys(faqData).map((key, index) => (
            <Grid key={index} item container xs={12} md={6}>
              <Typography sx={{ fontSize: '16px', fontWeight: '700', textAlign: 'left', color: theme.palette.mode === 'light' ? '#3f4254' : '#cdcdde' }}>{key}</Typography>
              <Grid sx={{ mt: 2 }}>
                {faqData[key].map((faq, i) => (
                  <>
                    { index % 2 === 0 ?
                      <CustomAccordion 
                        key={i} summary={faq.summary} 
                        details={faq.details} 
                        panel={key + i} 
                        expanded={expanded} 
                        handleChange={handleChange} 
                      />:
                      <CustomAccordion 
                        key={i} summary={faq.summary} 
                        details={faq.details} 
                        panel={key + i} 
                        expanded={expandedRight} 
                        handleChange={handleChangeRight} 
                      />
                    }
                  </>
                ))}
              </Grid>
            </Grid>
          ))}
        </Grid>
        <CreateTicket
          visible={createTicketModal}
          onClose={onCloseCreateTicketModal}
          onCreatedTicketSuccessed={onCreatedTicketSuccessed}
        />
        <SentTicketSuccessModal
          visible={successModal}
          onClose={onCloseSuccessModal}
          onCloseSuccess={onCloseSuccess}
        />
        <ScrollToTop
          smooth
          color="#009EF7"
        />
      </Container>
    </>
  );
}

export default FaqPage;
